import { render, staticRenderFns } from "./CaseTableTree.vue?vue&type=template&id=39687606&scoped=true&"
import script from "./CaseTableTree.vue?vue&type=script&lang=ts&"
export * from "./CaseTableTree.vue?vue&type=script&lang=ts&"
import style0 from "./CaseTableTree.vue?vue&type=style&index=0&id=39687606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39687606",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCheckbox,VTreeview})
